// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:30.456532
var courses = [];